import { FormikProps } from "formik"
import { FormikCheckBox } from "./CustomFormikFormFields"
import { MSG_INSPECTOR_AGREE } from "../../constants"


export const InspectorAgreeCheck = ({formik} : {formik: FormikProps<any>}) => {
  return (
  <div className='fv-row '>
    <div className='form-check form-check-sm form-check-custom form-check-solid mt-2 d-flex flex-row align-items-start gap-2'>
      <input
        {...formik.getFieldProps('inspectorAgree')}
        name='inspectorAgree'
        className='form-check-input'
        type='checkbox'
        disabled={formik.isSubmitting}
      />
      <div>
      <label className='form-check-label'>{MSG_INSPECTOR_AGREE}</label>
      {formik.errors.inspectorAgree && (
      <div className='ps-2 fv-plugins-message-container'>
        <div className='fv-help-block'>
          {`${formik.errors.inspectorAgree}`}
        </div>
      </div>
      )}
      </div>
    </div>
   
  </div>
  )
}

export const FormikInspectorAgreeCheck = () => {
  return(
    <div className="row my-2 px-2">
      <FormikCheckBox size="12" name="inspectorAgree" label={MSG_INSPECTOR_AGREE} />  
    </div>
  )
}